import HTRLogo from '../../../assets/svg/htr-logo.svg';
import HTRLogoDark from '../../../assets/svg/htr-logo-dark.svg';

export default function htrLogo(custom_style) {
    return( <>
        <img src={HTRLogo} className='logoClass' style={custom_style}/>
        <img src={HTRLogoDark} className='logoDarkClass' style={custom_style}/>
    </>)
}
